import * as React from "react";

import pageStyles from "./styles/StatsRowStyles";

function StatsRow() {
  const styles = pageStyles();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <p>
          +4.5M
          <br />
          <span>$FROIN repartidos</span>
        </p>
      </div>
      <div className={styles.card}>
        <p>
          +8.6M
          <br />
          <span>segundos reproducidos</span>
        </p>
      </div>
      <div className={styles.card}>
        <p>
          +20
          <br />
          <span>artistas expuestos</span>
        </p>
      </div>
      <div className={styles.card}>
        <p>
          +290
          <br />
          <span>espectadores recompensados</span>
        </p>
      </div>
    </div>
  );
}

export default StatsRow;
